module.exports = "pegasus/assets/logo-preview.png";